import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useMetricConversionService(config) {
	const user = useUserContext(config);
	const [service, setService] = useState(() => {
		return createMetricConversionService(user, config);
	});

	useEffect(() => {
		setService(createMetricConversionService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return service;
}

function createMetricConversionService(user, config) {
	const api = createAxiosApi("", user, config);

	function getAll(handleResponse, handleError) {
		api.get("MetricConversions/")
			.then(handleResponse)
			.catch(handleError);
	}

	function getById(metricConversionId, handleResponse, handleError) {
		api.get(`MetricConversions/${metricConversionId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function create(metricConversion, handleResponse, handleError) {
		api.post("MetricConversions/", metricConversion)
			.then(handleResponse)
			.catch(handleError);
	}

	function update(metricConversionId, metricConversion, handleResponse, handleError) {
		api.put(`MetricConversions/${metricConversionId}`, metricConversion)
			.then(handleResponse)
			.catch(handleError);
	}

	function deleteItem(metricConversionId, handleResponse, handleError) {
		api.delete(`MetricConversions/${metricConversionId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function importItems(metricConversions, handleResponse, handleError) {
		api.post("MetricConversions/import", metricConversions)
			.then(handleResponse)
			.catch(handleError);
	}

	return {
		getAll,
		getById,
		create,
		update,
		deleteItem,
		importItems
	};
}
